import { isCatchUpModuleEnabled } from '@office-start/ai-hub-config-service';
/**
 * By default, the Catchup module has the Native integration.
 * However, this guard allows you to switch to the MetaOS integration,
 * if needed using flighting.
 */
export var catchUpRouteGuard = function (props) {
    var canActivate = isCatchUpModuleEnabled(props.featureGates);
    return { canActivate: canActivate };
};
//# sourceMappingURL=catchUpRouteGuard.js.map